import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import _map from 'lodash.map'

import { axios } from '../../context/auth'
import SongExportView from '../songs/export-view'
import { pageView, PAGES } from '../../utils/analytics-tracker'
import computeNumbering from '../../utils/compute-numbering'

const ExportBreakSeparator = styled.div`
  display: flex;
  align-items: center;
  margin: 2em 0;
  page-break-before: auto;
  &::before, &::after {
    content: '';
    flex: 1;
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
  &::before { margin-right: 15px; }
  &::after { margin-left: 15px; }
  font-weight: bold;
  font-size: 1.2em;
`

const ExportNoteText = styled.div`
  padding: 0.75em 1em;
  margin: 0.5em 0;
  font-style: italic;
  color: ${({ theme }) => theme.bodyText};
  border-left: 3px solid ${({ theme }) => theme.borderColor};
`

const getEntries = (setlist) => {
  if (setlist.entries && setlist.entries.length > 0) {
    return setlist.entries.map(e => {
      if (e.song) {
        const songId = e.song._id || e.song
        const songObj = (setlist.songs || []).find(s => (s._id || s) === songId)
        return songObj || { _id: songId }
      }
      return e
    })
  }
  return setlist.songs || []
}

const ExportSetList = ({ setlistid }) => {
  const { setlistid: matchSetlistid } = useParams()

  const useSetlistId = setlistid || matchSetlistid
  const [setlist, setSetlist] = useState()

  const refreshSetList = useCallback(async () => {
    try {
      const response = await axios.get(`/api/setlists/${useSetlistId}`)
      setSetlist(response.data)
    } catch (err) {
      console.log(err)
    }
  })

  useEffect(() => {
    pageView(PAGES.SETLIST_EXPORT)
    refreshSetList()
  }, ['-'])

  if (!setlist) {
    return <div>loading</div>
  }
  return (
    <>
      <div className='ExportSetList'>
        <h1>{setlist.title}</h1>

        <br /><br />

        {_map(computeNumbering(getEntries(setlist)), ({ entry, songNumber }, idx) => {
          if (entry.type === 'note') {
            if (entry.isBreak) {
              return <ExportBreakSeparator key={`break-${idx}`}>{entry.text || 'Set Break'}</ExportBreakSeparator>
            }
            return <ExportNoteText key={`note-${idx}`}>{entry.text}</ExportNoteText>
          }
          return <SongExportView key={entry._id} song={entry} songNumber={songNumber} />
        })}
      </div>
    </>
  )
}

export default ExportSetList
